import { render, staticRenderFns } from "./ODAVF101.vue?vue&type=template&id=23090334"
import script from "./ODAVF101.vue?vue&type=script&lang=js"
export * from "./ODAVF101.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports